const fileValidator = (file, rules) => {
    if (!file) {
        return {
            result: true,
            message: ''
        }
    }

    if (rules.allowedTypes) {
        const regex = new RegExp(`(${rules.allowedTypes})`)

        if (!regex.test(file.name)) {
            const text = replaceAll(String(rules.allowedTypes), `|`, ', ' )
            return {
                result: false,
                message: `Formato de arquivo não suportado (suportados: ${text}).`
            }
        }
    }

    if (rules.maximumSize && file.size > rules.maximumSize) {
        return {
            result: false,
            message: `O tamanho do arquivo é manor que o permitido (limite ${bytesToSize(rules.maximumSize)}).`
        }
    }

    return {
        result: true,
        message: ''
    }
}

function bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

    if (bytes == 0) return '0 Byte'

    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

    return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}

export default fileValidator